import { Box, Skeleton } from '@internations/ds'
import { ReactElement } from 'react'

export const LayoutChildSkeleton = (): ReactElement => {
    return (
        <Box mt={5}>
            <Skeleton variant="rectangular" height="10rem" />
            <Skeleton height="40px" />
            <Skeleton height="40px" />
            <Skeleton height="40px" />
            <Skeleton height="40px" sx={{ mt: 2 }} />
        </Box>
    )
}
